import _ from "lodash";
import { useNavigate } from "react-router-dom";

const TickerHyperLinkComponent = (props: any) => {
    const navigate = useNavigate();
    const onLinkClick = async (event: any) => {
    navigate(`/dashboards/sl-quote/${props?.value}`)
  };

  return (
    <div>
      {!props?.data?.isTotalRow && _.isString(props?.value) && !(props?.node?.group) && (
        <span onClick={onLinkClick} style={{textDecoration: "underline", color:'#0d6efd', cursor:'pointer'}}>
          {" "}
          {props.value?.toUpperCase()}
        </span>
      )}

      {(props?.data?.isTotalRow || !_.isString(props?.value) || (props?.node?.group)) && (
        <div> {props?.value}</div>
      )}
    </div>
  );
};
export default TickerHyperLinkComponent;
